import React, { useState, useEffect } from "react";
import s from "./ProviderDetail.module.css";

//Servicios
import providersService from "../../../../api/providers/providersService";
import gamesService from "../../../../api/games/GamesService";

//assets
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

//Material
import {
  Grid,
  Box,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Typography,
  Avatar,
} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useTranslationException from "../../../../helpers/exceptions";
function ProviderDetail({ data, setData }) {
  const serviceProviders = providersService;
  const { allGameOffersActive } = useSelector((state) => state.gamma);
  const [providerGames, setProviderGames] = useState([]);
  const [loading, setLoading] = useState(false);
  const organization = useSelector((state) => state.gamma.activeOrganization);

  const { textColor } = useSelector((state) => state.local);
  const { t, i18n } = useTranslation();
  const dispatch = useDispatch();
  const showExpetion = useTranslationException(t, i18n);
  useEffect(() => {
    setLoading(true);
    serviceProviders
      .getGamesProvider(data.id, dispatch)
      .then((res) => {
        if (res !== "NOT_FOUND") {
          setProviderGames(res.gamesIds);
        }
      })
      .then(() => {
        gamesService
          .getAllActivesGameOffers(dispatch)
          .then(() => setLoading(false));
      })
      .catch((e) => {
        showExpetion.showErrorModalForServiceException(
          e,
          { icon: "warning" },
          t("anErrorOccurred,TryAgain"),
          t("sorryErrorOcurred"),
        );
        setLoading(false);
      });
  }, []);

  //TODO: Aplicar la expresion regular desde el config
  const formatCuit = (cuit) => {
    let formattedCuit = cuit
      .toString()
      .replace(/(\d{2})(\d{8})(\d{1})/, "$1-$2-$3");
    return formattedCuit;
  };

  return (
    <Grid container className={s.container}>
      <Grid item xs={11} className={s.titleContainer}>
        <ArrowBackIcon
          sx={{ color: "primary.main", fontSize: "4vh" }}
          onClick={() => {
            setData({
              ...data,
              active: false,
            });
          }}
          className={s.arrow}
        />
        <div className={s.title}>
          <h4>{data.businessName}</h4>
          <Box
            sx={{
              backgroundColor: "primary.main",
              color: textColor,
              fontSize: "4vh",
            }}
            className={s.chip}
          >
            {t("provider")}
          </Box>
        </div>
      </Grid>

      <Grid item container xs={11} className={s.data}>
        <Accordion
          defaultExpanded={true}
          className={s.accordion}
          sx={{ backgroundColor: "transparent", border: 0, boxShadow: "none" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: textColor }} />}
            sx={{ backgroundColor: "primary.main", borderRadius: "0 0 0 0" }}
          >
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: 300,
                fontFamily: "Roboto, sans-serif",
                color: textColor,
              }}
            >
              {t("moreInformation")}
            </Typography>
          </AccordionSummary>

          <AccordionDetails className={s.dataContainer}>
            <div className={s.item}>
              <h3>CUIT</h3>
              <p>{formatCuit(data.cuit)}</p>
            </div>
            <div className={s.item}>
              <h3>{t("taxCondition")}</h3>
              <p>{data.fiscalCondition}</p>
            </div>
            <div className={s.item}>
              <h3>{t("address")}</h3>
              <p>{data.address}</p>
            </div>
            <div className={s.item}>
              <h3>{t("type")}</h3>
              <p>{data.typeSupplier}</p>
            </div>
          </AccordionDetails>
        </Accordion>

        <Accordion
          defaultExpanded={false}
          className={s.accordion}
          sx={{ backgroundColor: "transparent", border: 0, boxShadow: "none" }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon sx={{ color: textColor }} />}
            sx={{ backgroundColor: "primary.main", borderRadius: "0 0 0 0" }}
          >
            <Typography
              sx={{
                fontSize: "1rem",
                fontWeight: 300,
                fontFamily: "Roboto, sans-serif",
                color: textColor,
              }}
            >
              {t("contact")}
            </Typography>
          </AccordionSummary>

          <AccordionDetails className={s.dataContainer}>
            <div className={s.item}>
              <h3>{t("phone")}</h3>
              <p>{formatCuit(data.phone)}</p>
            </div>
            <div className={s.item}>
              <h3>{t("Email")}</h3>
              <p>{data.email}</p>
            </div>
          </AccordionDetails>
        </Accordion>
      </Grid>

      <Grid item container xs={11} className={s.dataContainer}>
        {loading ? (
          <div className={s.loader}>
            <CircularProgress size={"4rem"} />
          </div>
        ) : (
          <TableContainer className={s.tableContainer}>
            <Table>
              <TableHead sx={{ backgroundColor: "primary.main" }}>
                <TableCell
                  sx={{
                    color: textColor,
                    fontSize: ".9rem",
                    fontWeight: 300,
                    fontFamily: "Roboto, sans-Serif",
                    height: "20px",
                  }}
                >
                  {t("games")}
                </TableCell>
              </TableHead>
              <TableBody>
                {allGameOffersActive
                  .filter((game) =>
                    providerGames?.includes(game.modality?.game?.id),
                  )
                  ?.map((item, i) => (
                    <React.Fragment key={i}>
                      <TableRow>
                        <TableCell>
                          <div className={s.gameName}>
                            <Avatar
                              sx={{ mr: 4 }}
                              src={item.modality?.game?.image}
                              alt={item.modality?.game?.name}
                            />
                            {item.modality?.game?.name}
                          </div>
                        </TableCell>
                      </TableRow>
                    </React.Fragment>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </Grid>
    </Grid>
  );
}

export default ProviderDetail;
